import { render } from "./index.vue?vue&type=template&id=03d7a3a7"
import script from "./games.ts?vue&type=script&lang=js"
export * from "./games.ts?vue&type=script&lang=js"

import "./games.scss?vue&type=style&index=0&lang=scss"
script.render = render

export default script